import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Timeline } from "../../../Constant";
import BasicTimeline from "./BasicTimeline";
import HoveringTimeline from "./HoveringTimeline";
import VariationTimeline from "./VariationTimeline";
import HorizontalTimeline from "./HorizontalTimeline";
import Timelines from "./Timelines";

const TimelineContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Timeline} parent={BonusUi} title={Timeline} />
      <Container fluid>
        <Row>
          <BasicTimeline />
          <HoveringTimeline />
          <VariationTimeline/>
          <HorizontalTimeline/>
          <Timelines/>
        </Row>
      </Container>
    </>
  );
};

export default TimelineContainer;
